//@flow
import React from 'react';
import AdditionalInfo
  from '../../../../../SummarySubSections/SummarySubSection/AdditionalInfo/AdditionalInfo';
import s from './LineItemTableSubSectionHeader.less';

type Props = {
  section: string,
  tableTitle: string,
  totalCost: number,
  sectionData?: ?Object,
};

const LineItemTableSubSectionHeader = (props: Props) => {
  const isMissingSection = props.section === 'Missing';
  return (
    <div className={`${s.subSectionTitle}`}>
      <h4 className={isMissingSection ? s.missing : ''}>
        {props.section}
      </h4>
      {!isMissingSection &&
        <AdditionalInfo additionalInfo={props.sectionData} />}
    </div>
  );
};

export default LineItemTableSubSectionHeader;



// WEBPACK FOOTER //
// ./src/components/CBDTables/LineItemTables/LineItemTablesContainer/LineItemTableSubSection/LineItemSubSectionHeader/LineItemTableSubSectionHeader.js